import axios from "axios";

export const formAuthHeaders = () => {
  // const token =
  //   localStorage.getItem("auth-token") &&
  //   JSON.parse(localStorage.getItem("auth-token")).token;
  return {
    headers: {
      // "Content-Type": "multipart/form-data",
      "Content-Type": "application/json",
    },
  };
};

const Axios = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    withCredentials: true,
  });

export default Axios;